module.exports = __webpack_public_path__ + "img/me-prova.92a6dfa3.png";